import React from 'react';
import PropTypes from 'prop-types';

/*
  Displays given address into a standard format
  for order details/edition and order creation
  when addresses are divided into 3 parts, street address, regional address and country
  example:
    Company Name (if showOptionalFields true and companyName exist)
    FirstName LastName (if showOptionalFields true)
    Rua de Test, nº15
    3030-789, Coimbra
    PORTUGAL
    123456789 (if showOptionalFields true)
    test@mobilu.eu (if showOptionalFields true)
*/
function FormattedAddress({
  address,
  showOptionalFields,
  nameContainer,
  addressContainer,
  containerClass,
  formatCompanyName,
  formatName,
}) {
  let existFirstName = false;
  let existLastName = false;
  if (showOptionalFields) {
    existFirstName = address?.firstName?.length > 0;
    existLastName = address?.lastName?.length > 0;
  }
  return (
    <div className={containerClass}>
      {showOptionalFields && address?.companyName && (
        <div className={formatCompanyName ? 'company-format-address' : ''}>
          {`${address?.companyName}`}
          <br />
          {address?.NIF ? (
            <>
              {address.NIF}
              <br />
            </>
          ) : null}
        </div>
      )}
      {showOptionalFields && (existFirstName || existLastName) && (
        <div
          id={nameContainer}
          className={
            showOptionalFields && address?.companyName && formatName
              ? 'with-company-name'
              : ''
          }
        >
          {`${existFirstName ? address.firstName : ''}${
            existLastName ? ` ${address.lastName}` : ''
          }`}
          <br />
        </div>
      )}
      <div id={addressContainer}>
        {address.address_1 || address.address}
        <br />
        {address.address_2 ? `${address.address_2}` : ''}
        {address.address_2 && <br />}
        {(address.zipCode || address.city) &&
          `${address?.zipCode || ''} ${address?.city || ''}`}
        <br />
        {address?.state?.length > 0 ? address.state : ''}
        {address.state && <br />}
        {address?.country ? address.country.toUpperCase() : ''}
        {showOptionalFields && address?.phone?.length > 0 && (
          <>
            <br />
            {address.phone}
          </>
        )}
        {showOptionalFields && address?.email?.length > 0 && (
          <>
            <br />
            <div className="email">{address.email}</div>
          </>
        )}
        {/* Used for multiple emails in payment by company */}
        {showOptionalFields && address?.emails?.length > 0 && (
          <>
            {address?.emails.map(email => (
              <>
                <br />
                <div className="email">{email}</div>
              </>
            ))}
          </>
        )}
        {showOptionalFields && !address?.companyName && address?.NIF ? (
          <>
            <br />
            {address.NIF}
            <br />
          </>
        ) : null}
      </div>
    </div>
  );
}

FormattedAddress.propTypes = {
  address: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    emails: PropTypes.arrayOf(PropTypes.string),
    phone: PropTypes.string,
    address: PropTypes.string,
    address_1: PropTypes.string,
    address_2: PropTypes.string,
    zipCode: PropTypes.string,
    state: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    companyName: PropTypes.string,
    NIF: PropTypes.string,
  }),
  // It shows the optional fields firstName, lastName, email, phone
  // sometimes we don't need to show them, Order Create (customer billing address)
  showOptionalFields: PropTypes.bool,
  // Custom id, so we can make some css or jquery changes (optional)
  nameContainer: PropTypes.string,
  addressContainer: PropTypes.string,
  containerClass: PropTypes.string,
  formatCompanyName: PropTypes.bool,
  formatName: PropTypes.bool,
};
FormattedAddress.defaultProps = {
  address: {
    zipCode: '',
    city: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
  },
  showOptionalFields: false,
  nameContainer: '',
  addressContainer: '',
  containerClass: '',
  formatCompanyName: true,
  formatName: false,
};

export default FormattedAddress;
